import packageJson from '../package.json';

export const envName = process.env.REACT_APP_ENV_NAME || process.env.NODE_ENV || 'development';
export const isProduction = envName === 'production';
export const isDevelopment = envName === 'development';
export const hemtURL = process.env.REACT_APP_HEMT_URL || 'https://telefonica-hemt.unetiq.com';
export const hemtApiURL = process.env.REACT_APP_HEMT_API_URL || 'https://telefonica-hemt.unetiq.com/api';
export const appURL = process.env.REACT_APP_URL || 'http://localhost:3000';
export const apiURL = process.env.REACT_APP_API_URL || 'http://localhost:5050/api';
export const auth0Domain = process.env.REACT_APP_AUTH0_DOMAIN || '';
export const auth0ClientId = process.env.REACT_APP_AUTH0_CLIENT_ID || '';
export const auth0Audience = process.env.REACT_APP_AUTH0_AUDIENCE || '';
export const sentryDsn = process.env.REACT_APP_SENTRY_DSN || '';
export const agGridLicense = process.env.REACT_APP_AG_GRID_LICENSE || '';
export const appTimezone = process.env.REACT_APP_TIMEZONE || 'Europe/Berlin';
export const version = process.env.REACT_APP_VERSION || packageJson?.version || '1.0.0';
export const buildHash = process.env.REACT_APP_BUILD_HASH || version;
export const helpURL = process.env.REACT_APP_HELP_URL || '';
// CALL-755: read the budget flag from the backend-injected runtime config first (window.
// __RUNTIME_CONFIG__, served by /config.js) so the module can be toggled via BUDGET_MODULE_ENABLED
// without a frontend rebuild. Fall back to the build-time env for local dev. `??` (not `||`) so an
// explicit runtime `false` is honored rather than treated as "unset".
export const budgetEnabled =
    window.__RUNTIME_CONFIG__?.budgetEnabled ?? process.env.REACT_APP_BUDGET_ENABLED !== 'false';
// CALL-809: same runtime-first pattern for the Louvre corridor-check pages — LOUVRE_MODULE_ENABLED
// on the backend hides the section (e.g. on prod while the UI is being agreed) without a rebuild.
export const louvreEnabled =
    window.__RUNTIME_CONFIG__?.louvreEnabled ?? process.env.REACT_APP_LOUVRE_ENABLED !== 'false';

if (!apiURL || !apiURL.startsWith('http')) {
    throw Error('Environment variable `REACT_APP_API_URL` needs to start with `http` or `https`');
}

const config = {
    version,
    buildHash,
    envName,
    isProduction,
    isDevelopment,
    appTimezone,
    appURL,
    apiURL,
    hemtURL,
    hemtApiURL,
    auth0Domain,
    auth0ClientId,
    auth0Audience,
    sentryDsn,
    agGridLicense,
    helpURL,
    budgetEnabled,
    louvreEnabled,
};

export default config;
